import React, { useState } from 'react'
import Style from './TaxiTab.module.css'
import TaxiRequests from '../../../Pages/TaxiPanel/TaxiRequests/TaxiRequests'
import TaxiFinishedRequest from '../../../Pages/TaxiPanel/TaxiFinishedRequest/TaxiFinishedRequest'
const TaxiTab = () => {
    const [checkedClass,setCheckdClass]=useState(false)
    const ClassHandler =()=>{
        setCheckdClass(false)
    }
    const ClassHandler2 =()=>{
        setCheckdClass(true)
    }
    let Content=null
    if(checkedClass) 
    {
        Content=<TaxiFinishedRequest/>
    }
    if(!checkedClass)
    {
        Content=<TaxiRequests/>
    }
    return (
        <div className={Style.PageHolder}>
            <header className={Style.TabsTitle}>
                <div className={checkedClass?Style.normal:Style.checked} onClick={ClassHandler}>سفر های فعلی</div>
                <div className={checkedClass?Style.checked:Style.normal} onClick={ClassHandler2}>سفر های قبلی</div>
            </header>
            {Content}
        </div>
    )
}

export default TaxiTab
